import api from '../axiosConfig';
import { ROLES } from '../config/apiEndpoints';

export const RoleService = {
    getAll: async (params = {}) => {
        try {
            const axiosParams = {};
            if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                if (params.page !== undefined) axiosParams.page = params.page + 1;
                if (params.limit) axiosParams.limit = params.limit;
            }
            const response = await api.get(ROLES.BASE, { params: axiosParams });
            const data = response.data;
            return data;
        } catch (error) {
            console.error('RoleService getAll error:', error);
            throw error;
        }
    },

    create: async ({ name, permissions }) => {
        try {
            const response = await api.post(ROLES.BASE, { name, permissions });
            return response.data;
        } catch (error) {
            console.error('RoleService create error:', error);
            throw error;
        }
    },

    update: async (id, { name, permissions }) => {
        try {
            const response = await api.put(ROLES.BY_ID(id), { name, permissions });
            return response.data;
        } catch (error) {
            console.error('RoleService update error:', error);
            throw error;
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(ROLES.BY_ID(id));
            return response.data;
        } catch (error) {
            console.error('RoleService delete error:', error);
            throw error;
        }
    },

    getPermissionsMatrix: async (params = {}) => {
        try {
            const axiosParams = {};
            if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                if (params.page !== undefined) axiosParams.page = params.page + 1;
                if (params.limit) axiosParams.limit = params.limit;
            }
            const response = await api.get(ROLES.PERMISSIONS_MATRIX, { params: axiosParams });
            const data = response.data;
            return data;
        } catch (error) {
            console.error('RoleService getPermissionsMatrix error:', error);
            throw error;
        }
    },

    updatePermissionsMatrix: async (matrixData, tenantId) => {
        try {
            const response = await api.put(ROLES.PERMISSIONS_MATRIX, matrixData, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data;
        } catch (error) {
            console.error('RoleService updatePermissionsMatrix error:', error);
            throw error;
        }
    },
};
